/** The bar a loading screen draws in place of the real navigation header. */

import { createThemedStyles } from '@repo/theme/styles';
import { View } from 'react-native';

/** Height of `<SkeletonNavBar>`, matching the real navigation header. */
export const SKELETON_NAV_BAR_HEIGHT = 64;

export type SkeletonNavBarProps = { children: React.ReactNode; paddingHorizontal: number };

/**
 * The header's surface, border, and height, with its children spread to the
 * two ends. The placeholder shapes are the caller's to supply.
 */
export function SkeletonNavBar({ children, paddingHorizontal }: SkeletonNavBarProps) {
    const s = useStyles();
    return <View style={[s.bar, { paddingHorizontal }]}>{children}</View>;
}

const useStyles = createThemedStyles((tokens) => ({
    bar: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: SKELETON_NAV_BAR_HEIGHT,
        backgroundColor: tokens.colors.colorSurfacePrimary,
        borderBottomWidth: 1,
        borderBottomColor: tokens.colors.colorBorderPrimary,
    },
}));
